<template>
  <Pay :tab="1" />
</template>
<script route="/hr/payment-manage/official-p-r">
  import Pay from '@/views/fin/salaryadministration/components/Pay_V1.jsx'
  export default {
    components: {
      Pay
    }
  }
</script>